import React from 'react';
import TopTradesTable from '../../components/analytics/TopTradesTable';
import DistributionHistogram from '../../components/analytics/DistributionHistogram';
import StreakPanel from '../../components/analytics/StreakPanel';
import RollingWinRateSparkline from '../../components/analytics/RollingWinRateSparkline';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { useAnalyticsData } from '../../context/AnalyticsDataContext';

const TradesSection: React.FC = () => {
  const { filters } = useAnalyticsData();

  return (
    <>
      <Card>
        <CardHeader><CardTitle>Top trades</CardTitle></CardHeader>
        <CardContent><TopTradesTable filters={filters} /></CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>P&amp;L distribution</CardTitle></CardHeader>
        <CardContent><DistributionHistogram filters={filters} /></CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Streaks</CardTitle></CardHeader>
        <CardContent><StreakPanel filters={filters} /></CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Rolling win rate</CardTitle></CardHeader>
        <CardContent><RollingWinRateSparkline filters={filters} /></CardContent>
      </Card>
    </>
  );
};

export default TradesSection;
